import { createContext, useContext } from "react";
import { zFloating, zIndexFloating, type ZFloatingHost } from "./zIndex";

export const FloatingLayerContext = createContext<ZFloatingHost>("content");

/** The floating bands for the nearest host — see zIndex.ts. `*ZIndex` are the
 *  raw numbers, for components that must set `style={{ zIndex }}` instead. */
export const useFloatingLayer = () => {
  const host = useContext(FloatingLayerContext);
  return {
    host,
    popover: zFloating[host].popover,
    tooltip: zFloating[host].tooltip,
    popoverZIndex: zIndexFloating[host].popover,
    tooltipZIndex: zIndexFloating[host].tooltip,
  };
};
